exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss"), undefined);

// module
exports.push([module.id, ".FacebookAuthButton__button___3bPJS {\n    background-color: transparent;\n    height: 2.4rem;\n    margin-bottom: 0.75rem!important;\n}\n\n.FacebookAuthButton__label___34LWu {\n    color: " + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["inverseMainTextColour"] + ";\n\tdisplay: flex;\n    flex-direction: row;\n}\n\n.FacebookAuthButton__text___2HDAA {\n\tmin-width: 11rem;\n}\n\n.FacebookAuthButton__logo___3mcoa {\n\theight: 1.5rem;\n    margin-right: 1.5rem;\n}\n\n.FacebookAuthButton__facebookColor___Hnir- {\n    color: #6798e5!important;\n}\n", ""]);

// exports
exports.locals = {
	"inverseMainTextColour": "" + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["inverseMainTextColour"] + "",
	"button": "FacebookAuthButton__button___3bPJS",
	"label": "FacebookAuthButton__label___34LWu",
	"text": "FacebookAuthButton__text___2HDAA",
	"logo": "FacebookAuthButton__logo___3mcoa",
	"facebookColor": "FacebookAuthButton__facebookColor___Hnir-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/FacebookAuthButton.icss
// module id = 1559
// module chunks = 0